<template>
  <a
    v-tooltip="{
      content: tooltip,
      classes: 'badge-theme',
    }"
    :class="badgeClass"
    :href="href"
    :target="target"
    @click.prevent="goto"
  >
    <font-awesome-icon :icon="icon" />
    {{ name }}

    <template v-if="openNew && href">
      <font-awesome-icon :icon="['fal', 'share-square']" />
    </template>
    <template v-else-if="entityId && href">
      <font-awesome-icon :icon="['fal', 'play']" />
    </template>
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },

    entityId: {
      type: [Number, String],
    },
    openNew: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      required: false,
      default: "badge-bordered",
    },
    icon: {
      type: Array,
      required: false,
      default: () => ["fal", "user-hard-hat"],
    },
    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  computed: {
    href() {
      if (this.entityId) {
        if (
          this.$can("read", "user", "not-owned-users") ||
          this.entityId === this.$auth.user().id
        ) {
          return `/users/${this.entityId}/edit`;
        }
      }

      return null;
    },
    target() {
      return this.entityId && this.openNew && this.href ? "_blank" : null;
    },
    badgeClass() {
      return `badge ${this.color} ${this.size}`;
    },
  },

  methods: {
    goto() {
      if (!this.entityId || !this.href) {
        return;
      }

      if (this.openNew) {
        window.open(this.href);
      } else {
        this.$router.push({
          name: "users.edit",
          params: { id: this.entityId },
        });
      }
    },
  },
};
</script>
